const TOKEN_KEY = "osmix_buyer_token";

let memoryToken: string | null = null;

const canUseStorage = () => typeof window !== "undefined" && Boolean(window.localStorage);

export const getBuyerAuthToken = (): string | null => {
	if (memoryToken) return memoryToken;
	if (!canUseStorage()) return null;
	memoryToken = window.localStorage.getItem(TOKEN_KEY);
	return memoryToken;
};

export const setBuyerAuthToken = (token: string | null): void => {
	memoryToken = token;
	if (!canUseStorage()) return;
	if (token) window.localStorage.setItem(TOKEN_KEY, token);
	else window.localStorage.removeItem(TOKEN_KEY);
};

export const buyerAuthTokenKey = TOKEN_KEY;
